import { AsyncValidatorFn, ValidationErrors, Validators } from '@angular/forms';
import { map, Observable, of, switchMap, timer } from 'rxjs';

export interface EmailExistenceChecker {
  exists(email: string): Observable<boolean | null>;
}

export interface EmailExistsValidatorOptions {
  /** Value loaded from the backend; it is never validated while unchanged. */
  skipValue?: () => string | null | undefined;
  debounceMs?: number;
}

const normalize = (value: string | null | undefined) => (value ?? '').trim().toLowerCase();

export function emailExistsValidator(
  checker: EmailExistenceChecker,
  options: EmailExistsValidatorOptions = {}
): AsyncValidatorFn {
  const debounceMs = options.debounceMs ?? 500;

  return (control): Observable<ValidationErrors | null> => {
    const value = normalize(control.value);

    if (!value || Validators.email(control) || value === normalize(options.skipValue?.())) {
      return of(null);
    }

    return timer(debounceMs).pipe(
      switchMap(() => checker.exists(value)),
      // Unknown (null) results are accepted so a lookup outage does not block saving.
      map(exists => (exists === false ? { emailNotFound: true } : null))
    );
  };
}
